import React from 'react';
import { createRoot } from 'react-dom/client';
import '../css/style.scss';

export default Widget => (container, props) => {
  const { locale } = props;
  const root = createRoot(container);
  root.render(<div className="checkout__widgets">
    <div className='checkout__widgets-content'>
      <Widget
        {...props}
        locale={locale || 'en_US'} />
    </div>
  </div>);
  return {
    destroy() {
      root.unmount();
    },
  };
};
